"use client"
  import __i18nConfig from '@next-translate-root/i18n'
  import AppDirI18nProvider from 'next-translate/AppDirI18nProvider'
  import { useSearchParams as __useSearchParams, useParams as __useParams } from 'next/navigation'
  import { use as __use, Suspense as __Suspense } from 'react'
  import __loadNamespaces from 'next-translate/loadNamespaces'

  ;
import NextError from 'next/error';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
function GlobalError({ error, }: {
    error: Error & {
        digest?: string;
    };
}) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);
    return (<html>
      <body>
        <NextError statusCode={0}/>
      </body>
    </html>);
}


  export default function __Next_Translate_new__199860e6e2b__(props) {
    const searchParams = __useSearchParams()
    const params = __useParams()
    const detectedLang = params.lang ?? searchParams.get('lang')

    if (detectedLang === 'favicon.ico') return <GlobalError {...props} />

    if (globalThis.__NEXT_TRANSLATE__ && !detectedLang) return <GlobalError {...props} />

    const lang = detectedLang ?? __i18nConfig.defaultLocale
    const config = {
      ...__i18nConfig,
      locale: lang,
      loaderName: 'client /global-error',
      pathname: '/',
    }

    return (
      <__Suspense fallback={null}>
        <__Next_Translate__child__199860e6e2b__ 
          {...props} 
          config={config} 
          promise={__loadNamespaces({ ...config, loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)), })}
         />
      </__Suspense>
    )
  }

  function __Next_Translate__child__199860e6e2b__({ promise, config, ...props }) {
    const { __lang, __namespaces } = __use(promise);
    const oldNamespaces = globalThis.__NEXT_TRANSLATE__?.namespaces ?? {};
    globalThis.__NEXT_TRANSLATE__ = { lang: __lang, namespaces: { ...oldNamespaces, ...__namespaces }, config };
    return <GlobalError {...props} />;
  }
